// extracted by mini-css-extract-plugin
export var aiButtonContainer = "_a5-0";
export var orangeButton = "_a5-1";